export default __webpack_public_path__ + "static/media/bg.d8747572.jpg";